module.exports = __webpack_public_path__ + "img/about.511f5df3.jpg";